import { auditFormService } from '#apps/client-web/features/audit-form/services/audit-form';
import { ReactQueryClientService } from '#apps/client-web/app/services/react-query-client';
import { useLogger } from '#apps/client-web/app/hooks/use-logger';
import { FormPageLayout } from '#apps/client-web/app/components/form-page-layout';

import { CenteredLayout } from '#packages/web/foundations/layouts/centered-layout';

import { AuditFormEcmsPageContainer } from './audit-form-ecms-page.container';
import { useAuditFormEcmsPageViewModel } from './audit-form-ecms-page.view-model';

export const AuditFormEcmsPage = () => {
  const logger = useLogger('pages/audit-form-ecms');

  const viewModel = useAuditFormEcmsPageViewModel({
    auditFormService,
    queryClient: ReactQueryClientService.offlineQueryClient,
    logger,
  });

  return (
    <FormPageLayout
      title="ECMs"
      isFormChanged={viewModel.form.formState.isDirty}
      onSubmit={viewModel.onSubmit}
      isSubmitDisabled={viewModel.updateMutationState.state === 'pending'}>
      <CenteredLayout horizontal>
        <AuditFormEcmsPageContainer viewModel={viewModel} />
      </CenteredLayout>
    </FormPageLayout>
  );
};
